(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/account-selector/assets/javascripts/account-selector-container.js') >= 0) return;  svs.modules.push('/components/marketplace/account-selector/assets/javascripts/account-selector-container.js');
"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _svs$components$marke = svs.components.marketplace.accountSelector,
  AccountSelector = _svs$components$marke.AccountSelector,
  helpers = _svs$components$marke.helpers;
const USER_PLACEHOLDER = svs.components.marketplace.accountSelector.constants.USER_PLACEHOLDER;
const AccountSelectorContainer = props => {
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    stateAccounts = _useState2[0],
    setAccounts = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    stateDrawNumber = _useState4[0],
    setDrawNumber = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    stateProductId = _useState6[0],
    setProductId = _useState6[1];
  const _useState7 = useState(USER_PLACEHOLDER),
    _useState8 = _slicedToArray(_useState7, 2),
    stateSelectedId = _useState8[0],
    setSelectedId = _useState8[1];
  const _useState9 = useState(undefined),
    _useState0 = _slicedToArray(_useState9, 2),
    stateUserAccountBalance = _useState0[0],
    setUserAccountBalance = _useState0[1];
  useEffect(() => {
    if (!props.userAccountBalance) {
      svs.components.account_balance.get(false, balance => {
        setUserAccountBalance(Number(balance));
      });
    }
  }, []);
  const handleDataUpdate = _ref => {
    let accounts = _ref.accounts,
      drawNumber = _ref.drawNumber,
      productId = _ref.productId,
      userAccountBalance = _ref.userAccountBalance;
    const _ref2 = helpers.getCurrentAccount() || {},
      selectedId = _ref2.activatedDrawId;
    setAccounts(accounts);
    setDrawNumber(drawNumber);
    setProductId(productId);
    if (selectedId) {
      setSelectedId(selectedId);
    } else {
      setSelectedId(USER_PLACEHOLDER);
    }
    if (userAccountBalance) {
      setUserAccountBalance(userAccountBalance.toString());
    } else {
      svs.components.account_balance.get(false, balance => {
        setUserAccountBalance(balance);
      });
    }
  };
  useEffect(() => {
    helpers.observer.subscribe(handleDataUpdate, {
      emitCurrentValue: true
    });
    return () => {
      helpers.observer.unsubscribe(handleDataUpdate);
    };
  }, []);
  return React.createElement(AccountSelector, _extends({
    accounts: stateAccounts,
    drawNumber: stateDrawNumber,
    productId: stateProductId,
    selectedId: stateSelectedId,
    userAccountBalance: stateUserAccountBalance
  }, props));
};
setGlobal('svs.components.marketplace.accountSelector.AccountSelectorContainer', AccountSelectorContainer);

 })(window);